/* eslint-disable import/prefer-default-export */
import * as types from '../action.types';

export function addMessage(type, text, duration = 4000) {
  return {
    type: types.ADD_MESSAGE,
    payload: {
      type,
      duration,
      text,
    },
  };
}

export function deleteMessage(id) {
  return {
    type: types.DELETE_MESSAGE,
    payload: id,
  };
}
